module.exports = __webpack_public_path__ + "static/media/mastercard.38682d9c.webp";